import { render } from "./EditPassword.vue?vue&type=template&id=25c42f7e"
import script from "./EditPassword.vue?vue&type=script&lang=js"
export * from "./EditPassword.vue?vue&type=script&lang=js"

import "./EditPassword.vue?vue&type=style&index=0&id=25c42f7e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__